import React from "react";
import CustomButton from "components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import NoDataImg from "assets/img/no-data-found.jpg";
import Loader from "components/Loader";

const SurveySelection = ({ surveys, onSelectSurvey, isLoading }) => {
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center" style={{ padding: "100px 0" }}>
        <Loader />
      </div>
    );
  }

  if (!surveys || surveys.length === 0) {
    return (
      <div className="d-flex justify-content-center flex-column align-items-center">
        <img alt="" src={NoDataImg} width={"70%"} />
        <div>
          No worries, you will get survey questions when management will create
        </div>
      </div>
    );
  }

  return (
    <div className="survey-selection-container">
      <div className="mb-4">
        <h5 className="mb-2">
          <strong>Available Surveys</strong>
        </h5>
        <p className="text-muted">
          Select a survey to begin. You can only take one survey at a time.
        </p>
      </div>

      <div className="surveys-cards">
        <div className="row surveyRow">
          {surveys.map((survey) => (
            <div key={survey.survey_id} className="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-6 mb-4">
              <div className={`card h-100 d-flex flex-column survey-list-card ${
                survey.totalQuestions === 0 ? 'no-questions' : 
                survey.isCompleted ? 'completed' : 'available'
              }`}>
                <div className="card-body flex-grow-1 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="card-title mb-1 text-truncate flex-grow-1 me-2">
                      <strong>{survey.survey_title}</strong>
                    </h5>
                    {survey.totalQuestions === 0 ? (
                      <span className="badge bg-warning survey-status-pill">No Questions</span>
                    ) : survey.isCompleted ? (
                      <span className="badge bg-success survey-status-pill">Completed</span>
                    ) : null}
                  </div>
                  
                  <div className="d-flex align-items-center mb-2 gap-3">
                    <span className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faQuestionCircle} className="me-1 text-primary" />
                      <small className="text-muted">
                        {survey.totalQuestions} {survey.totalQuestions === 1 ? 'question' : 'questions'}
                      </small>
                    </span>
                    {survey.answeredQuestions > 0 && (
                      <span className="d-flex align-items-center">
                        <small className="text-muted">
                          Progress: {survey.answeredQuestions}/{survey.totalQuestions}
                        </small>
                      </span>
                    )}
                  </div>

                  <div className="mt-auto">
                    {survey.totalQuestions === 0 ? (
                      <div className="text-center py-2">
                        <p className="text-muted mb-0">No Questions Added Yet</p>
                      </div>
                    ) : survey.isCompleted ? (
                      <div className="text-center py-2">
                        <FontAwesomeIcon icon={faCheckCircle} className="text-success mb-2" style={{ fontSize: "2rem" }} />
                        <p className="text-muted mb-0">Survey Completed</p>
                      </div>
                    ) : (
                      <CustomButton
                        buttonClass="btn btn-primary w-100"
                        onClick={() => onSelectSurvey(survey.survey_id)}
                        disabled={survey.isCompleted}
                      >
                        {survey.answeredQuestions > 0 ? "Continue Survey" : "Start Survey"}
                      </CustomButton>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SurveySelection;
